import { render, staticRenderFns } from "./find-tutor.vue?vue&type=template&id=65fb3615&scoped=true&"
import script from "./find-tutor.vue?vue&type=script&lang=js&"
export * from "./find-tutor.vue?vue&type=script&lang=js&"
import style0 from "./find-tutor.vue?vue&type=style&index=0&id=65fb3615&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb3615",
  null
  
)

export default component.exports